const topics = [
  { label: '# 悬疑剧', count: '320部', hot: true },
  { label: '# 古装剧', count: '580部', hot: true },
  { label: '# 都市爱情', count: '460部', hot: true },
  { label: '# 职场剧', count: '210部', hot: false },
  { label: '# 仙侠奇幻', count: '180部', hot: true },
  { label: '# 刑侦剧', count: '290部', hot: false },
  { label: '# 喜剧', count: '350部', hot: false },
  { label: '# 韩剧', count: '420部', hot: true },
  { label: '# 港剧', count: '260部', hot: false },
  { label: '# 动漫番剧', count: '600部', hot: true },
  { label: '# 纪录片', count: '150部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            探索不同类型的影视资源，发现你的下一个心头好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-300 border ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200/60 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/60 hover:bg-background-200/50 hover:border-background-300'
              }`}
            >
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.hot ? 'text-foreground-900' : 'text-foreground-700'
              }`}>
                {topic.label}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-primary-600' : 'text-foreground-500'
              }`}>
                {topic.count}
              </span>
              {topic.hot && (
                <span className="text-accent-500 text-xs">
                  <i className="ri-fire-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}